import { z } from "zod";
import { MetaSchema } from "./shared";
import { TransferPaymentFineEnum } from "../enums";

export const userLoanSchema = z.object({
  id: z.string().uuid(),
  uid: z.number().int().nullable(),
  startDate: z.string().datetime().or(z.string()),
  endDate: z.string().datetime().or(z.string()),
  paidInstallments: z.number().int(),
  status: z.string(),
  liquidityValue: z.string(),
  marginCallValue: z.string(),
  freeMarginValue: z.string(),
  amount: z.string(),
  targetLtv: z.string(),
  currentLtv: z.string(),
  remainingAmount: z.string(),
  reliability: z.string(),
  transferPaymentFineType:
    TransferPaymentFineEnum.transferPaymentFineTypeSchema,
  receivedCurrency: z.string(),
  initialCollateralPrice: z.string(),
  unpaidInstallments: z.number().int(),
  collateralAmount: z.string(),
  transferredAmount: z.string().nullable(),
  purpose: z.string(),
  penalty: z.string().nullable(),
  monthlyRepay: z.string(),
  acceptedAt: z.string().datetime().or(z.string()).nullable(),
  nextRepaymentDate: z.string().datetime().or(z.string()),
  lastInstallmentAt: z.string().datetime().or(z.string()).nullable(),
  updatedAt: z.string().datetime().or(z.string()),
  createdAt: z.string().datetime().or(z.string()),
});

export type UserLoan = z.infer<typeof userLoanSchema>;

export const loanEventSchema = z.object({
  index: z.number().optional(),
  id: z.string().uuid(),
  amount: z.string(),
  latePenalty: z.string(),
  latePenaltyPerOnDays: z.number().int(),
  transactionType: z.string(),
  description: z.string().nullable(),
  status: z.string(),
  dueDate: z.string().datetime().or(z.string()).nullable().optional(),
  uid: z.number().int().nullable().optional(),
  lastCalculateLatePenalty: z.string().datetime().or(z.string()).nullable(),
  details: z.any().nullable(),
  createdAt: z.string().datetime().or(z.string()),
  paymentAt: z.string().datetime().or(z.string()).nullable(),
  updatedAt: z.string().datetime().or(z.string()),
  userLoan: userLoanSchema,
});

export type LoanEvent = z.infer<typeof loanEventSchema>;

const LoansLatestEventsResponse = z.object({
  data: z.tuple([z.array(loanEventSchema), z.number().int()]),
  meta: MetaSchema.default,
});

export type LoansLatestEventsResponseType = z.infer<
  typeof LoansLatestEventsResponse
>;

export default LoansLatestEventsResponse;
